import { z } from "zod";

/**
 * Sign-in payload validation.
 *
 * Security note: we deliberately do NOT enforce the registration
 * password policy (8 char min / 100 char max) on sign-in. The backend
 * is the only legitimate authority on whether a credential is valid,
 * and surfacing the policy via a client-side gate (disabled button,
 * inline error, character counter, HTML `minLength`) leaks the policy
 * to attackers and to credentials predating any policy change. We
 * only require a non-empty password so the form has SOMETHING to
 * submit; the backend returns a generic "invalid credentials" error
 * for any failure beyond that.
 */
export const signinSchema = z.object({
  emailOrUsername: z.string().trim().min(2, "Please enter at least 2 characters."),
  password: z.string().min(1, "Please enter your password."),
});

export const passwordRecoverySchema = z.object({
  emailOrUsername: z.string().trim().min(2, "Please enter a valid email or username (minimum 2 characters)"),
});

export const otpRequestSchema = z.object({
  emailOrUsername: z.string().trim().min(2, "Please enter at least 2 characters."),
});

export const otpVerifySchema = z.object({
  verificationCode: z.string().regex(/^\d{6}$/, "Please enter the 6-digit verification code."),
});

export const registerSchema = z.object({
  email: z.string().trim().email("Please enter a valid email address."),
  username: z.string().trim().min(2, "Username must be at least 2 characters long.").max(30, "Username must be 30 characters or fewer."),
  password: z.string().min(8, "Password must be at least 8 characters long").max(100, "Password must not exceed 100 characters"),
  isPrivate: z.boolean(),
});

